import { IconPropTypes } from '@/legacy/types';

const TutorialsIcon = (props: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props.width || 15}
			height={props.height || 15}
			fill='none'
			scale={props.scale || 1}
			strokeWidth={props.strokeWidth || 1}
			{...props}
		>
			<path
				fill={props.color || 'currentColor'}
				fillRule='evenodd'
				d='M5.598 4.06a.5.5 0 0 1 .513.024l4 2.667a.5.5 0 0 1 0 .832l-4 2.666a.5.5 0 0 1-.778-.416V4.5a.5.5 0 0 1 .265-.44Zm.735 4.84 2.599-1.733-2.599-1.733V8.9Z'
				clipRule='evenodd'
			/>
			<path
				fill={props.color || 'currentColor'}
				fillRule='evenodd'
				d='M7.167 0a7.167 7.167 0 1 1 0 14.333A7.167 7.167 0 0 1 7.167 0Zm0 1a6.167 6.167 0 1 0 0 12.333A6.167 6.167 0 0 0 7.167 1Z'
				clipRule='evenodd'
			/>
		</svg>
	);
};

export default TutorialsIcon;
